export default "__VITE_ASSET__BGCxd7_i__"